import React from 'react';
import classNames from 'classnames';
import { T } from '@sm/intl';
import { SurveyLink, SurveyLinkProps } from '../SurveyLink';
import useSurveyStyles from './useStyles';

const DEFAULT_COPY = {
  TEXT: {
    id: 'ExitLink.Text',
    defaultMessage: 'Exit',
    description: '[Type: Link][Vis: med] - Exit link label',
  },
};

function getLinkDetails(
  label?: React.ReactNode,
  defaultLabel?: React.ReactNode
): { label?: React.ReactNode; translate?: 'yes' | 'no' } {
  return { label: label ?? defaultLabel, translate: label ? 'no' : undefined };
}

export type Props = Omit<SurveyLinkProps, 'underline'> & { label?: string };

function ExitLink({ href, label, className, ...anchorProps }: Props): React.ReactElement {
  const { exitLink } = useSurveyStyles();
  const link = getLinkDetails(label, <T desc={DEFAULT_COPY.TEXT} />);
  return (
    <SurveyLink
      href={href}
      translate={link.translate}
      className={classNames(exitLink, className)}
      data-testid="ExitLink__Link"
      underline="never"
      {...anchorProps}
    >
      {link.label}
    </SurveyLink>
  );
}

export default ExitLink;
